<template>
	<el-dialog  title="关联任务" top="0px" width="95%" :close-on-click-modal="false" :visible.sync="dialogVisible" @close="dialogVisible = false">
		<div style="height: 550px;width: 100%;">
			<RelationSearch ref="relationSearch" style="height: 100px;overflow-y: auto;overflow-x: hidden;" @onSearch="onSearch"></RelationSearch>
			<el-table
				ref="multipleTable"
				:data="tableData"
				tooltip-effect="dark"
				style="width: 100%;"
				height="400"
				@selection-change="handleSelectionChange">
				<el-table-column
				  type="selection"
				  width="55">
				</el-table-column>
				<el-table-column
				  prop="INSTANCE"
				  label="编号"
				  width="150">
				</el-table-column>
				<el-table-column
				  prop="TASKNAME"
				  label="名称">
				</el-table-column>
				<el-table-column
				  prop="TASKSTATENAME"
				  label="状态"
				   width="150" >
				</el-table-column>
			  </el-table>
		</div>
		<div style="height: 50px;text-align: right;box-sizing: border-box;padding:5px 0;">
			<el-button @click="dialogVisible=false">取 消</el-button>
			<el-button @click="save" type="primary">保 存</el-button>
		</div>
	</el-dialog>
</template>
<script>
import { getToken } from "@/util/auth";
const cookieUser = getToken();
import { getTaskListByParas, AddGroupSubTask } from "@/api/modules/basicData/task";
import RelationSearch from "./RelationSearch.vue"
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
export default {
	name:"relationTask",
	components: {
		RelationSearch,
	},
	data(){
		return{
			dialogVisible:false,
			paras:{
				PageIndex: 1,
				PageSize: 100,
				TypeIndex: -1,
				TaskParas: {
					CurrentUserId:cookieUser.userId,
					TypeIndex:-1,
					ExcuteState: '',
				}
			},
			tableData: [],
			multipleSelection:[]
		}
	},
	computed: {
		...mapState({
			curTask: state=> state.task.curTask,
		}),
	},
	mounted(){
		if(this.tableData.length == 0){
			this.onSearch()
		}
		
	},
	watch: {
		dialogVisible(val){
			if(val){
				setTimeout(()=>{
					this.$refs.relationSearch.onClear(1);
					this.$refs.multipleTable.clearSelection();
				},400)
				this.multipleSelection = [];
			}
		}
	},
	methods:{
		onSearch(paras){
			var data = this.paras;
			if(paras){
				var newParas = Object.assign(data.TaskParas, paras);
				data.TaskParas = newParas;
			}
			getTaskListByParas(data).then((res)=>{
				if(res && res.Items){
					this.tableData = res.Items;
				}
			})
		},
		handleSelectionChange(val){
			this.multipleSelection = val;
		},
		save(){
			console.info("进入....save")
			if(!this.multipleSelection.length){
				this.$message.error("未选择任务!")
				return false;
			}
			var subTaskIds = [];
			console.info("subTaskIds",subTaskIds)
			console.info("curTask",this.curTask.ID)
			for (var i = 0; i < this.multipleSelection.length; i++) {
				var a = this.multipleSelection[i];
				subTaskIds.push(a.ID);
			}
			console.info("subTaskIds2",subTaskIds)
			AddGroupSubTask(subTaskIds.toString(),this.curTask.ID).then((res)=>{
				console.info("任务关联："+res)
				if(res.ResultCode == 1){
					this.$message.success("关联成功!")
					this.multipleSelection = [];
					this.$refs.multipleTable.clearSelection();
					this.dialogVisible = false;
					this.$store.dispatch("GetTaskGroupTaskList")
				}
			})
		}
		
	}
}
</script>
<style scoped lang="less">
	
</style>
